// extracted by mini-css-extract-plugin
module.exports =  {"legendPriceIconsRoot":"LegendPriceIcons-module__legendPriceIconsRoot--uhpGo","iconSpan":"LegendPriceIcons-module__iconSpan--REVfL"};